import * as React from 'react';
import { Box, GDSStyleObject } from '@leagueplatform/genesis-core';
import { useBasePage } from 'hooks/use-base-page.hook';
import { AppNavBarComponent } from './header-nav/navbar/nav.component';
import { FooterComponent } from './footer/footer.component';

interface Props {
  isPrivatePage?: boolean;
  children: React.ReactNode;
  css?: GDSStyleObject;
}

export const BasePage = ({
  children,
  isPrivatePage = true,
  css,
  ...boxProps
}: Props) => {
  const { shouldShowNavBar, shouldShowFooter, mainStyles } = useBasePage({
    isPrivatePage,
  });

  return (
    <>
      {shouldShowNavBar && <AppNavBarComponent />}
      <Box
        as="main"
        css={{
          ...mainStyles,
          ...css,
        }}
        {...boxProps}
      >
        {children}
      </Box>
      {shouldShowFooter && <FooterComponent />}
    </>
  );
};
